module.exports = __webpack_public_path__ + "static/media/downline.f8e31746.svg";